declare global {
  interface Document { documentMode?: any;}
}

export function isBrowserIE() {
  return window.document.documentMode;
}
